import { login, getCaptcha, getPublicKey } from "@/api/system1/user";
import { setToken, setRefreshToken } from "@/utils/auth";
import JSEncrypt from 'jsencrypt';
export default {
  data() {
    return {
      loginParams: {
        username: '',
        password: '',
        captchaKey: '',
        captchaCode: ''
      },
      captchaBase64: '',
      publicKey: '',
      submitting: false,
      loginRules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        captchaCode: [{
          required: true,
          trigger: "blur",
          message: '请输入验证码'
        }]
      }
    };
  },
  mounted() {
    this.getCaptcha();
    this.getPublicKey();
  },
  methods: {
    handleSubmit() {
      if (this.submitting) return;
      this.submitting = true;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          let params = {
            ...this.loginParams
          };
          let encrypt = new JSEncrypt();
          encrypt.setPublicKey(this.publicKey); //此处为RSA公钥
          params.username = encrypt.encrypt(params.username);
          params.password = encrypt.encrypt(params.password);
          login(params).then(res => {
            const {
              accessToken,
              refreshToken
            } = res.data;
            setToken('Bearer ' + accessToken);
            setRefreshToken(refreshToken);
            this.$router.push('/');
          }).catch(error => {
            this.getCaptcha();
            this.loginParams.captchaCode = '';
            localStorage.setItem('accessToken', '');
            localStorage.setItem('refreshToken', '');
          }).finally(() => {
            this.submitting = false;
          });
        } else {
          this.submitting = false;
        }
      });
    },
    /** 获取验证码 */
    getCaptcha() {
      getCaptcha().then(data => {
        this.loginParams.captchaKey = data.data.captchaKey;
        this.captchaBase64 = data.data.captchaBase64;
      });
    },
    //获取公钥
    getPublicKey() {
      getPublicKey().then(response => {
        if (response.code == 0) {
          this.publicKey = response.data;
        }
      });
    }
  },
  computed: {
    loginFormValid() {
      return this.$refs.loginForm ? this.$refs.loginForm.form.valid : true;
    }
  }
};